const reducer = (state = '', action) =>{
    switch(action.type){
        case "setSubCompanySearch": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  